<template>
  <div :id="id" class="paypal-button"></div>
</template>

<script>
import Vue from 'vue'
import paypal from 'paypal-checkout'

export default {
  name: 'PaypalButton',
  props: {
    id: {
      type: String,
      required: true
    },
    payment: {
      type: Function,
      required: true
    },
    onAuthorize: {
      type: Function,
      required: true
    },
    onCancel: {
      type: Function,
      required: false,
      default: () => {}
    }
  },
  mounted () {
    this.render()
  },
  methods: {
    render () {
      let options = {
        env: Vue.config.PAYPAL_SANDBOX ? 'sandbox' : 'production',
        locale: 'th_TH',
        style: {
          size: 'responsive',
          shape: 'rect',
          color: 'gold'
        },
        payment: this.payment,
        onAuthorize: this.onAuthorize,
        onCancel: this.onCancel
      }
      if (Vue.config.PAYPAL_SANDBOX) {
        options.client = {
          sandbox: Vue.config.PAYPAL_CLIENT_ID
        }
      } else {
        options.client = {
          production: Vue.config.PAYPAL_CLIENT_ID
        }
      }

      paypal.Button.render(options, '#' + this.id).then(() => {
        this.$emit('ready')
      })
    }
  }
}
</script>

<style scoped>
.paypal-button {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// PaypalButton.vue?76f2819c